import { useEffect, useState } from "react";
import DashboardRRHH from "./DashboardRRHH"; // Este será el componente actual de RRHH
import Despidos from "./Despidos"; // Nuevo componente para la pestaña Despidos
import Organigrama from "./Organigrama"; // Nuevo componente para la pestaña Organigrama

const RRHH = () => {
  const [vistaActiva, setVistaActiva] = useState("dashboard");

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold fs-4 text-center w-100">Recursos Humanos</h2>
      </div>

      {/* PESTAÑAS */}
      <ul className="nav nav-tabs justify-content-center mb-4">
        <li className="nav-item">
          <button
            className={`nav-link ${vistaActiva === "dashboard" ? "active" : ""}`}
            onClick={() => setVistaActiva("dashboard")}
          >
            <i className="bi bi-bar-chart-line-fill me-2"></i>Dashboard
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${vistaActiva === "despidos" ? "active" : ""}`}
            onClick={() => setVistaActiva("despidos")}
          >
            <i className="bi bi-person-x-fill me-2"></i>Gestión de Salidas
          </button>
        </li>

        <li className="nav-item">
          <button
            className={`nav-link ${vistaActiva === "organigrama" ? "active" : ""}`}
            onClick={() => setVistaActiva("organigrama")}
          >
            <i className="bi bi-diagram-3 me-2"></i>Organigrama
          </button>
        </li>
      </ul>

      {/* CONTENIDO DE CADA PESTAÑA */}
      {vistaActiva === "dashboard" && <DashboardRRHH />}
      {vistaActiva === "despidos" && <Despidos />}
      {vistaActiva === "organigrama" && <Organigrama />}
    </div>
  );
};

export default RRHH;
